import ConfidenceIndicator from "./ConfidenceIndicator";

export default ConfidenceIndicator;
